export const ACCESS_CODES = {
  DASHBOARD: 'DASHBOARD',
  BEDELIA_STUDENTS: 'BEDELIA_STUDENTS',
  BEDELIA_TEACHERS: 'BEDELIA_TEACHERS',
  BEDELIA_REVALIDATIONS: 'BEDELIA_REVALIDATIONS',
  BEDELIA_DISCOUNTS: 'BEDELIA_DISCOUNTS',
  DICTATED_INSCRIPTIONS: 'DICTATED_INSCRIPTIONS',
  DICTATED_COURSES: 'DICTATED_COURSES',
  EXAM_INSCRIPTIONS: 'EXAM_INSCRIPTIONS',
  EXAMS: 'EXAMS',
  FINANCE_CURRENT_ACCOUNT: 'FINANCE_CURRENT_ACCOUNT',
  FINANCE_PRICE_INCREASES: 'FINANCE_PRICE_INCREASES',
  FINANCE_EMPLOYEES: 'FINANCE_EMPLOYEES',
  FINANCE_PAYMENT_METHODS: 'FINANCE_PAYMENT_METHODS',
  FINANCE_CONTRACTS: 'FINANCE_CONTRACTS',
  FINANCE_DOCUMENTS: 'FINANCE_DOCUMENTS',
  FINANCE_SCHOLARSHIPS: 'FINANCE_SCHOLARSHIPS',
  FINANCE_DELINQUENCY: 'FINANCE_DELINQUENCY',
  PAYROLL_PERIODS: 'PAYROLL_PERIODS',
  PAYROLL_MANAGEMENT: 'PAYROLL_MANAGEMENT',
  PAYROLL_CONFIG: 'PAYROLL_CONFIG',
  PAYROLL_SALARY_INCREASES: 'PAYROLL_SALARY_INCREASES',
  PAYROLL_ABSENCES: 'PAYROLL_ABSENCES',
  TIME_CLOCK: 'TIME_CLOCK',
  TIME_CLOCK_REPORT: 'TIME_CLOCK_REPORT',
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  ADMIN_AUDIT: 'ADMIN_AUDIT',
  ADMIN_REPORTS: 'ADMIN_REPORTS',
  ADMIN_INSTITUTION: 'ADMIN_INSTITUTION',
  ADMIN_SYSTEM: 'ADMIN_SYSTEM',
  ACADEMIC_STUDIES: 'ACADEMIC_STUDIES',
  ACADEMIC_STUDY_TYPES: 'ACADEMIC_STUDY_TYPES',
  ACADEMIC_STUDY_PLANS: 'ACADEMIC_STUDY_PLANS',
  ACADEMIC_SUBJECTS: 'ACADEMIC_SUBJECTS',
  ACADEMIC_ATTENDANCE: 'ACADEMIC_ATTENDANCE',
  ACADEMIC_CALENDAR: 'ACADEMIC_CALENDAR',
  ACADEMIC_CLASSROOMS: 'ACADEMIC_CLASSROOMS',
  ACADEMIC_IMPORT_ESCOLARIDAD: 'ACADEMIC_IMPORT_ESCOLARIDAD',
  LIBRARY_MEDIA: 'LIBRARY_MEDIA',
  LIBRARY_LOANS: 'LIBRARY_LOANS',
};

/** path de ruta admin → códigos de acceso requeridos */
export const ROUTE_ACCESS_MAP = {
  '/dashboard': [ACCESS_CODES.DASHBOARD],
  '/default': [ACCESS_CODES.BEDELIA_STUDENTS],
  '/default/:id': [ACCESS_CODES.BEDELIA_STUDENTS],
  '/revalidations': [ACCESS_CODES.BEDELIA_REVALIDATIONS],
  '/course-discounts': [ACCESS_CODES.BEDELIA_DISCOUNTS],
  '/teaching': [ACCESS_CODES.BEDELIA_TEACHERS],
  '/teaching/:id': [ACCESS_CODES.BEDELIA_TEACHERS],
  '/inscriptions': [ACCESS_CODES.DICTATED_INSCRIPTIONS],
  '/dictated-courses': [ACCESS_CODES.DICTATED_COURSES],
  '/dictated-courses/:id/list': [ACCESS_CODES.DICTATED_COURSES],
  '/dictated-courses/:id/absences': [ACCESS_CODES.DICTATED_COURSES],
  '/dictated-courses/:id/teachers': [ACCESS_CODES.DICTATED_COURSES],
  '/dictated-courses/:id/acta': [ACCESS_CODES.DICTATED_COURSES],
  '/exam-inscriptions': [ACCESS_CODES.EXAM_INSCRIPTIONS],
  '/exams': [ACCESS_CODES.EXAMS],
  '/exams/:id/acta': [ACCESS_CODES.EXAMS],
  '/exams/:id/tribunal': [ACCESS_CODES.EXAMS],
  '/current-account': [ACCESS_CODES.FINANCE_CURRENT_ACCOUNT, ACCESS_CODES.BEDELIA_STUDENTS],
  '/price-increases': [ACCESS_CODES.FINANCE_PRICE_INCREASES],
  '/employees': [ACCESS_CODES.FINANCE_EMPLOYEES],
  '/employees/:id': [ACCESS_CODES.FINANCE_EMPLOYEES],
  '/payment-methods': [ACCESS_CODES.FINANCE_PAYMENT_METHODS],
  '/employee-contracts': [ACCESS_CODES.FINANCE_CONTRACTS],
  '/employee-documents': [ACCESS_CODES.FINANCE_DOCUMENTS],
  '/scholarships': [ACCESS_CODES.FINANCE_SCHOLARSHIPS, ACCESS_CODES.BEDELIA_STUDENTS],
  '/delinquency': [ACCESS_CODES.FINANCE_DELINQUENCY],
  '/payroll': [ACCESS_CODES.PAYROLL_PERIODS],
  '/payroll-management': [ACCESS_CODES.PAYROLL_MANAGEMENT],
  '/employee-payroll-config': [ACCESS_CODES.PAYROLL_CONFIG],
  '/salary-increases': [ACCESS_CODES.PAYROLL_SALARY_INCREASES],
  '/absence-management': [ACCESS_CODES.PAYROLL_ABSENCES],
  '/time-clock': [ACCESS_CODES.TIME_CLOCK],
  '/time-record-report': [ACCESS_CODES.TIME_CLOCK_REPORT],
  '/system-admin': [ACCESS_CODES.ADMIN_SYSTEM],
  '/user-management': [ACCESS_CODES.USER_MANAGEMENT],
  '/audit-log': [ACCESS_CODES.ADMIN_AUDIT],
  '/reports': [ACCESS_CODES.ADMIN_REPORTS],
  '/institution-config': [ACCESS_CODES.ADMIN_INSTITUTION],
  '/studies': [ACCESS_CODES.ACADEMIC_STUDIES],
  '/study-types': [ACCESS_CODES.ACADEMIC_STUDY_TYPES],
  '/studyPlans': [ACCESS_CODES.ACADEMIC_STUDY_PLANS],
  '/subjects': [ACCESS_CODES.ACADEMIC_SUBJECTS],
  '/course-attendance': [ACCESS_CODES.ACADEMIC_ATTENDANCE],
  '/academic-calendar': [ACCESS_CODES.ACADEMIC_CALENDAR],
  '/classrooms': [ACCESS_CODES.ACADEMIC_CLASSROOMS],
  '/import-escolaridades': [ACCESS_CODES.ACADEMIC_IMPORT_ESCOLARIDAD],
  '/library': [ACCESS_CODES.LIBRARY_MEDIA],
  '/loans': [ACCESS_CODES.LIBRARY_LOANS],
};

export function enrichRoutesWithAccess(routes) {
  return routes.map((route) => {
    if (route.category && route.items?.length) {
      return { ...route, items: enrichRoutesWithAccess(route.items) };
    }
    if (route.layout === '/auth') return route;
    const accesses = ROUTE_ACCESS_MAP[route.path];
    if (!accesses) return route;
    return { ...route, accesses };
  });
}
